// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-survey.page-warmup-screen {
  padding: 20px 12px;
  background-color: var(--white);
  border-radius: 12px;

  box-shadow: 0 10px 30px 0 rgba(17, 21, 32, 0.09);
}

.page-warmup-screen .page-title {
  margin-top: 8px;
  margin-bottom: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  color: var(--orange);
}

.page-warmup-screen .page-description {
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  color: var(--black);
}

.page-warmup-screen .info-component-container .description-plan {
  margin-top: 24px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: var(--gray);
}

.page-warmup-screen .button-container {
  margin-bottom: auto;
  display: block;
}

.page-warmup-screen .button-container button {
  height: 60px;
  padding: 18px 20px 16px;
  border-radius: 40px;

  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.024em;
  text-align: center;
  outline: none;
  cursor: pointer;
  box-shadow: none;
  color: var(--white);
  background: var(--orange);
  max-width: 100%;
}

.page-warmup-screen .policy-container {
   margin: 10px auto 0;
}

@media screen and (orientation: landscape) {
  .page-warmup-screen .policy-container {
    position: static;
  }
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/warm-up-screen.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;;EAEnB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;;EAEnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".page-survey.page-warmup-screen {\n  padding: 20px 12px;\n  background-color: var(--white);\n  border-radius: 12px;\n\n  box-shadow: 0 10px 30px 0 rgba(17, 21, 32, 0.09);\n}\n\n.page-warmup-screen .page-title {\n  margin-top: 8px;\n  margin-bottom: 0;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 36px;\n  color: var(--orange);\n}\n\n.page-warmup-screen .page-description {\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 28px;\n  color: var(--black);\n}\n\n.page-warmup-screen .info-component-container .description-plan {\n  margin-top: 24px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  color: var(--gray);\n}\n\n.page-warmup-screen .button-container {\n  margin-bottom: auto;\n  display: block;\n}\n\n.page-warmup-screen .button-container button {\n  height: 60px;\n  padding: 18px 20px 16px;\n  border-radius: 40px;\n\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: -0.024em;\n  text-align: center;\n  outline: none;\n  cursor: pointer;\n  box-shadow: none;\n  color: var(--white);\n  background: var(--orange);\n  max-width: 100%;\n}\n\n.page-warmup-screen .policy-container {\n   margin: 10px auto 0;\n}\n\n@media screen and (orientation: landscape) {\n  .page-warmup-screen .policy-container {\n    position: static;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
